<template lang="pug">
    .settings(v-if='settings')
        div
            | {{ $i18n.t('trainer.trainer_gameFormSetting_tableSize') }}:
            | {{ settings.difficult.name }}
        div(v-if="settings.timeLimit")
            | {{ $i18n.t('progress.progress_preview_timeLimit') }}:
            | {{ limitName }}
        div(v-if="settings.displaySpeed")
            | {{ $i18n.t('trainer.trainer_gameFormSetting_displaySpeed') }}:
            | {{ speedName }}
        slot
</template>

<script>
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import gamePreviewMixin from '../../../utils/trainer/gamePreviewMixin';

    export default {
        mixins: [TrainerUtilities, gamePreviewMixin],
        props: {
            game: Object,
            parameters: Object,
            userId: Number,
            parametersFrom: {
                type: String,
                default: 'homework',
            },
            withIcon: Boolean,
        },
        computed: {
            limitName() {
                return (
                    this.settings.timeLimit +
                    ' ' +
                    this.$i18n.tc('trainer.trainer_gamePreview_timeParamMinuteDeclination', this.settings.timeLimit)
                );
            },
            speedName() {
                return (
                    this.settings.displaySpeed +
                    ' ' +
                    this.$i18n.tc('olympiads.olympiads_timeDeclination_seconds', this.settings.displaySpeed)
                );
            },
        },
    };
</script>
